module.exports = __webpack_public_path__ + "img/yishi11.a4c9ed63.jpg";